// extracted by mini-css-extract-plugin
export default {"container":"MenuOption_container__2lr7o","selected":"MenuOption_selected__oGHsl"};